/* global axios */
import ApiClient from './ApiClient';

class LeadsReportsAPI extends ApiClient {
  constructor() {
    super('leads_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getLeadsReport({ from, to, strategyId, funnelId, groupBy }) {
    return axios.get(`${this.url}`, {
      params: {
        since: from,
        until: to,
        strategy_id: strategyId,
        funnel_id: funnelId,
        group_by: groupBy,
      },
    });
  }

  getStrategies() {
    return axios.get(`${this.url}/strategies`);
  }

  getClicksReport({ from, to, strategyId }) {
    return axios.get(`${this.url}/clicks`, {
      params: {
        since: from,
        until: to,
        strategy_id: strategyId,
      },
    });
  }
}

export default new LeadsReportsAPI();
